const PASS_BANNER_TIME = 5000;

export function initInformationBanner() {
  const labels = Array.from(
    document.querySelectorAll('.information-banner__label')
  );

  const buttons = Array.from(
    document.querySelectorAll('.information-banner__button')
  );

  if (labels.length > 0 && buttons.length > 0) {
    autoPassBannerInfo(labels, buttons);
  }

  buttons.forEach(button =>
    button.addEventListener('click', () => {
      showBannerLabelById(button.dataset.bannerId, labels, buttons);
    })
  );
}

const showBannerLabelById = (id, labels, buttons) => {
  labels.forEach(label =>
    label.classList.remove('information-banner__label--visible')
  );

  buttons.forEach(button =>
    button.firstElementChild.classList.remove('information-banner__dot--active')
  );

  labels[id].classList.add('information-banner__label--visible');
  buttons[id].firstElementChild.classList.add(
    'information-banner__dot--active'
  );
};

const autoPassBannerInfo = (labels, buttons) => {
  const content = document.querySelector('.information-banner');
  const max = labels.length - 1;
  let currentIndex = 1;

  if (content) {
    setInterval(() => {
      showBannerLabelById(currentIndex, labels, buttons);
      currentIndex++;

      if (currentIndex > max) {
        currentIndex = 0;
      }
    }, PASS_BANNER_TIME);
  }
};
